import { Controller } from "@hotwired/stimulus"

// lib/filtriCatalogo.js (censimento, blocco B2) sulle schede della pagina: ogni scheda dentro l'elemento `elenco`
// porta in data-filtri-bando i dati che il server manda (enti delle fonti collegate, regioni del territorio,
// tipologia proposta o «da classificare», stato e giorni alla chiusura). Mai indovinati. Stesse regole di
// BandiHelper#passa.
export const FILTRI_VUOTI = { ente: "", regione: "", tipologia: "", stato: "", scadenza: "" }
export const SENZA_FONTE = "__senza_fonte"

export function passa(b, f) {
  if (f.ente === SENZA_FONTE ? (b.enti || []).length > 0 : f.ente && !(b.enti || []).includes(f.ente)) return false
  const reg = b.regioni_filtro || ["*"]
  if (f.regione && !reg.includes("*") && !reg.includes(f.regione)) return false
  const tip = b.tipologia || { stato: "da_classificare", forme: [] }
  if (f.tipologia === "da_classificare" ? tip.stato !== "da_classificare" : f.tipologia && !(tip.forme || []).includes(f.tipologia)) return false
  const t = b.temporal || {}
  if (f.stato && t.state !== f.stato) return false
  if (f.scadenza === "senza") return t.days_to_close === undefined || t.days_to_close === null
  if (f.scadenza) return t.state === "open" && typeof t.days_to_close === "number" && t.days_to_close <= Number(f.scadenza)
  return true
}

export const filtriAttivi = (f) => Object.values(f).some(Boolean)

// leggiFiltri/salvaFiltri di pages/TrovaBando.js: i filtri restano in questo browser finché l'utente non li toglie.
// Solo le chiavi dei filtri con valori testuali; senza localStorage (o con un valore illeggibile) i filtri vuoti.
export function leggiFiltri(chiave) {
  try {
    const v = JSON.parse(window.localStorage.getItem(chiave) || "{}")
    return { ...FILTRI_VUOTI, ...Object.fromEntries(Object.entries(v || {}).filter(([k, x]) => k in FILTRI_VUOTI && typeof x === "string")) }
  } catch { return { ...FILTRI_VUOTI } }
}
function salvaFiltri(chiave, v) {
  try { window.localStorage.setItem(chiave, JSON.stringify(v)) } catch { /* the filters work without saving */ }
}

export default class extends Controller {
  static targets = ["filtro", "conto", "azzera"]
  static values = { elenco: String, chiave: String }

  connect() {
    if (this.chiaveValue) {
      const salvati = leggiFiltri(this.chiaveValue)
      this.filtroTargets.forEach((s) => { s.value = salvati[s.dataset.filtro] ?? "" })
    }
    this.applica(null)
  }

  filtri() {
    return Object.fromEntries(this.filtroTargets.map((s) => [s.dataset.filtro, s.value]))
  }

  schede() {
    const elenco = this.elencoValue && document.getElementById(this.elencoValue)
    return elenco ? [...elenco.querySelectorAll("[data-filtri-bando]")] : []
  }

  // dal cambio di un filtro (evento) o da «Togli i filtri»: i filtri si salvano; all'avvio solo si applicano
  applica(event) {
    const f = this.filtri()
    const schede = this.schede()
    let mostrati = 0
    schede.forEach((el) => {
      let b = {}
      try { b = JSON.parse(el.dataset.filtriBando || "{}") } catch { b = {} }
      const ok = passa(b, f)
      el.hidden = !ok
      if (ok) mostrati += 1
    })
    const totale = schede.length
    this.contoTarget.firstChild.nodeValue = `${mostrati} di ${totale} bandi`
    this.azzeraTarget.hidden = !filtriAttivi(f)
    const vuoto = this.elencoValue && document.getElementById(this.elencoValue)?.querySelector("[data-filtri-vuoto]")
    if (vuoto) vuoto.hidden = !(mostrati === 0 && totale > 0)
    if (this.chiaveValue && event !== null) salvaFiltri(this.chiaveValue, { ...FILTRI_VUOTI, ...f })
    this.dispatch("applicati", { detail: { mostrati, totale } })
  }

  azzera() {
    this.filtroTargets.forEach((s) => { s.value = "" })
    this.applica()
  }
}
